"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Pagination;

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.parse-float.js");

var _react = require("react");

var _Dropdown = _interopRequireDefault(require("../inputs/Dropdown"));

var _PaginationModule = _interopRequireDefault(require("../../assets/styles/components/Pagination.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Pagination(_ref) {
  let {
    direction,
    numPages = 20,
    size = "default",
    currentPage = 1,
    onChange: _onChange,
    prevText = "Prev",
    nextText = "Next",
    labelNumPages = "of"
  } = _ref;
  const [pages, setpages] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    let arr = [];

    for (let i = 0; i < numPages; i++) {
      arr.push(i + 1);
    }

    setpages(arr);
  }, [numPages]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "\n            ".concat(_PaginationModule.default.pagination, "\n            ").concat(size === "mini" ? _PaginationModule.default.size_mini : size === "compact" ? _PaginationModule.default.size_compact : size === "default" ? _PaginationModule.default.size_default : size === "large" ? _PaginationModule.default.size_large : _PaginationModule.default.size_default, "\n        "),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
      onClick: () => {
        _onChange(currentPage - 1);
      },
      disabled: pages[0] && currentPage.toString() === pages[0].toString(),
      className: "".concat(_PaginationModule.default.pg_prev, " ").concat(_PaginationModule.default.pg_btn),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
        "data-baseweb": "icon",
        title: "",
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9 12C9 12.2652 9.10536 12.5196 9.29289 12.7071L13.2929 16.7071C13.6834 17.0976 14.3166 17.0976 14.7071 16.7071C15.0976 16.3166 15.0976 15.6834 14.7071 15.2929L11.4142 12L14.7071 8.70711C15.0976 8.31658 15.0976 7.68342 14.7071 7.29289C14.3166 6.90237 13.6834 6.90237 13.2929 7.29289L9.29289 11.2929C9.10536 11.4804 9 11.7348 9 12Z"
        })
      }), prevText]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dropdown.default, {
      direction: direction,
      size: size,
      styling: {
        maxWidth: "6rem"
      },
      keepSelectedItem: true,
      options: pages,
      selected: [currentPage],
      onChange: value => {
        _onChange(value.label);
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: _PaginationModule.default.pg_txt,
      children: [labelNumPages, " ", numPages]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
      onClick: () => {
        _onChange(currentPage + 1);
      },
      disabled: pages[pages.length - 1] && parseFloat(currentPage) >= parseFloat(pages[pages.length - 1]),
      className: "".concat(_PaginationModule.default.pg_next, " ").concat(_PaginationModule.default.pg_btn),
      children: [nextText, /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
        "data-baseweb": "icon",
        title: "",
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.29289 7.29289C8.90237 7.68342 8.90237 8.31658 9.29289 8.70711L12.5858 12L9.29289 15.2929C8.90237 15.6834 8.90237 16.3166 9.29289 16.7071C9.68342 17.0976 10.3166 17.0976 10.7071 16.7071L14.7071 12.7071C14.8946 12.5196 15 12.2652 15 12C15 11.7348 14.8946 11.4804 14.7071 11.2929L10.7071 7.29289C10.3166 6.90237 9.68342 6.90237 9.29289 7.29289Z"
        })
      })]
    })]
  });
}